//copied from v1
import React from "react";
import { Box } from "@indeed/ifl-components";
import { expressive } from "@indeed/ifl-tokens";

const PullQuote = ({ maxW, contentW, children }) => (
  <Box
    as="blockquote"
    sx={{
      borderLeft: `4px solid ${expressive.aqua["700"]}`,
      pl: [5, 5, 5, 6],
      py: [2, 2, 2, 3],
      ml: [0, 0, 0, `-${(maxW - contentW) / 2}px`],
      width: "100%",
      fontSize: [4, 4, 4, 6],
      color: "neutral.1000",
      my: 8,
      p: {
        display: "inline",
      },
    }}
  >
    {children}
  </Box>
);

export default PullQuote;
